import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LibSharedCommonModule } from '@solvace/common';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcButtonModule } from '@solvace/component/svc-btn';
import { SvcDialogsModule } from '@solvace/component/svc-dialogs';
import { SvcPrinterModalComponent } from './svc-printer-modal.component';
import { SvcPrinterMiniatureComponent } from './svc-printer-miniature/svc-printer-miniature.component';
import { SvcPrinterImgCarouselComponent } from './svc-printer-img-carousel/svc-printer-img-carousel.component';

@NgModule({
  declarations: [
    SvcPrinterModalComponent,
    SvcPrinterMiniatureComponent,
    SvcPrinterImgCarouselComponent,
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    SvcDialogsModule,
    SvcButtonModule,
    TranslocoModule,
  ],
  exports: [
    SvcPrinterModalComponent,
    SvcPrinterMiniatureComponent,
  ],
})
export class SvcPrinterModule { }
